import { render, staticRenderFns } from "./addDetail.vue?vue&type=template&id=1a80e4d1&scoped=true"
import script from "./addDetail.vue?vue&type=script&lang=js"
export * from "./addDetail.vue?vue&type=script&lang=js"
import style0 from "./addDetail.vue?vue&type=style&index=0&id=1a80e4d1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a80e4d1",
  null
  
)

export default component.exports